// extracted by mini-css-extract-plugin
export var option = "_c8-0";
export var optionCard = "_c8-f";
export var optionContent = "_c8-g";
export var optionIcon = "_c8-i";
export var optionIconBox = "_c8-h";
export var optionLabel = "_c8-j";
export var optionPill = "_c8-m";
export var optionPillBadge = "_c8-p";
export var optionPillIcon = "_c8-n";
export var optionPillLabel = "_c8-o";
export var optionRadio = "_c8-k";
export var optionRadioInner = "_c8-l";
export var optionReveal = "_c8-2";
export var optionRevealDelay0 = "_c8-3";
export var optionRevealDelay1 = "_c8-4";
export var optionRevealDelay10 = "_c8-d";
export var optionRevealDelay11 = "_c8-e";
export var optionRevealDelay2 = "_c8-5";
export var optionRevealDelay3 = "_c8-6";
export var optionRevealDelay4 = "_c8-7";
export var optionRevealDelay5 = "_c8-8";
export var optionRevealDelay6 = "_c8-9";
export var optionRevealDelay7 = "_c8-a";
export var optionRevealDelay8 = "_c8-b";
export var optionRevealDelay9 = "_c8-c";
export var optionSelected = "_c8-1";